import React from "react"
import VerticalTab from "../../../../components/Tab/VerticalTab"
import Card from "../../../../components/Card/Card"

const SideBar = ({ setActiveTab, activeTab, userRole, isSupervisor }) => {

  return (
    <Card className="flex flex-col px-6 py-5 w-[240px] shrink-0 gap-4">
      <div className="flex flex-col gap-4 text-text-secondary text-md">
        {(userRole === 'customer' || isSupervisor) && <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="payments" title="Payments" />}
        {(userRole === 'customer' || isSupervisor) && <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="schedule" title="Schedule" />}

        {(userRole === 'affiliate' || userRole === 'affiliateGroupsAdmin') && <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="payments" title="Payments" />}
      </div>
    </Card>
  )
}

export default SideBar